@if (variant === 'stacked') {
<div class="cnslng_cmn cnslng_cmn--stacked">
    <div class="cnslng_cmn__body">
        @if (isSpecialTenant) {
        <h2>{{'NeedSupport?' | translate}}</h2>
        <p>{{'Callthehelplineorsubmitaticket' | translate}}</p>
        } @else {
        <h2>{{'StayInformed,StayInspired!' | translate}}</h2>
        <p>{{'Dontmissoutonourlatestblogposts' | translate}}</p>
        }
    </div>
    <figure class="cnslng_cmn__figure">
        <img src="assets/images/explore_section.png" alt="" aria-hidden="true">
    </figure>
    <button type="button" class="cnslng_cmn__cta" (click)="navigate(isSpecialTenant)">
        {{ (isSpecialTenant ? 'Support' : 'ExploreNow') | translate }}
        <app-icon name="right-arrow"></app-icon>
    </button>
</div>
} @else {
<div class="cnslng_cmn">
    @if (isSpecialTenant) {
    <div class="cnslng_cmn__body">
        <h2>{{'NeedSupport?' | translate}}</h2>
        <p>{{'Callthehelplineorsubmitaticket' | translate}}</p>
        <button type="button" class="btnn btn_secondary br_50 sm" (click)="navigate(isSpecialTenant)">
            {{'Support' | translate}}
            <app-icon name="right-arrow"></app-icon>
        </button>
    </div>
    } @else {
    <div class="cnslng_cmn__body">
        <h2>{{'StayInformed,StayInspired!' | translate}}</h2>
        <p>{{'Dontmissoutonourlatestblogposts' | translate}}</p>
        <button type="button" class="btnn btn_secondary br_50 sm" (click)="navigate(isSpecialTenant)">
            {{'ExploreNow' | translate}}
            <app-icon name="right-arrow"></app-icon>
        </button>
    </div>
    }
    <figure class="cnslng_cmn__figure">
        <img src="assets/images/explore_section.png" alt="" aria-hidden="true">
    </figure>
</div>
}
